import { css } from 'styled-components/macro';

export const carouselBoxCss = css`
  height: 100%;
  border-radius: 20px;
  box-shadow: 0px 1px 14px 0px #0000001f;
  padding: 3rem;
  margin: 0 auto;
  margin-top: 2rem;
  position: relative;
  width: 98%;
  @media (max-width: 768px) {
    padding: 2rem;
  }
  @media (max-width: 500px) {
    padding: 1rem;
  }

  h3 {
    font-size: 24px;
    font-weight: 700;
    line-height: 29px;
    @media (max-width: 500px) {
      font-size: 19px;
    }
  }
  p {
    font-size: 18px;
    font-weight: 400;
    line-height: 24px;
    @media (max-width: 500px) {
      font-size: 15px;
    }
  }
  h4 {
    font-size: 18px;
    font-weight: 700;
    margin: 0;
    @media (max-width: 500px) {
      font-size: 15px;
    }
  }
  h5 {
    font-size: 14px;
    font-weight: 400;
    margin: 0;
    @media (max-width: 500px) {
      font-size: 10px;
    }
  }
`;

export const authorCss = css`
  display: flex;
  margin-top: 36px;
  align-items: center;
  @media (max-width: 500px) {
    flex-direction: column;
    align-items: flex-start;
    > div {
      margin: 0;
    }
  }
`;

export const quotesCss = css`
  position: absolute;
  z-index: -1;
  left: 1.6rem;
`;
